const productsMap = {
  "collections/memphis": {
    eventName: "view_item_list",
    items: [
      {
        name: "wave",
        category: "fronts/lacquered",
        variant: "butter-yellow",
      },
      {
        name: "blade",
        category: "fronts/lacquered",
        variant: "honest-blue",
      },
    ],
  },
  "collections/norwegian-wood/by-model": {
    eventName: "view_item_list",
    items: [
      {
        name: "pure",
        category: "fronts/veneered",
        variant: "smoked-oak",
      },
      {
        name: "modern",
        category: "fronts/veneered",
        variant: "natural-oak",
      },
      {
        name: "stripe",
        category: "fronts/veneered",
        variant: "american-walnut",
      },
      {
        name: "blade",
        category: "fronts/veneered",
        variant: "natural-birch",
      },
    ],
  },
  "collections/norwegian-wood/by-veneer": {
    eventName: "view_item_list",
    items: [
      {
        name: "blade",
        category: "fronts/veneered",
        variant: "natural-birch",
      },
      {
        name: "modern",
        category: "fronts/veneered",
        variant: "natural-oak",
      },

      {
        name: "pure",
        category: "fronts/veneered",
        variant: "smoked-oak",
      },
      {
        name: "stripe",
        category: "fronts/veneered",
        variant: "american-walnut",
      },
      {
        name: "blade",
        category: "fronts/veneered",
        variant: "bog oak",
      },
    ],
  },
  "collections/terra": {
    eventName: "view_item_list",
    items: [
      {
        name: "classic",
        category: "fronts/lacquered",
        variant: "khaki",
      },
      {
        name: "modern",
        category: "fronts/lacquered",
        variant: "terracotta",
      },
      {
        name: "pure",
        category: "fronts/lacquered",
        variant: "greige",
      },
      {
        name: "pure",
        category: "fronts/lacquered",
        variant: "sand",
      },
      {
        name: "pure",
        category: "fronts/lacquered",
        variant: "mdf",
      },
    ],
  },
  "collections/ceramics": {
    eventName: "view_item_list",
    items: [
      {
        name: 'The plate “Moments. In act"',
        category: "ceramics",
      },
      {
        name: 'Plate "Terra Luna"',
        category: "ceramics",
      },
      {
        name: 'Plate "Halina. Relax"',
        category: "ceramics",
      },
    ],
  },
  "shelving-concept/open-shelves": {
    eventName: "view_item",
    items: [
      {
        name: "Open Shelves",
        category: "shelving",
      },
    ],
  },
  "shelving-concept/single-shelf": {
    eventName: "view_item",
    items: [
      {
        name: "Norwegian Wood Single Shelf",
        category: "shelving",
      },
    ],
  },
  "shelving-concept/shelving-unit": {
    eventName: "view_item",
    items: [
      {
        name: "Norwegian Wood Shelving Unit",
        category: "shelving",
      },
    ],
  },
  "samples-selection": {
    eventName: "view_item_list",
    items: [
      {
        name: "Terra Collection Colour Sample",
        category: "samples",
      },
      {
        name: "Stripe model sample",
        category: "samples",
      },
      {
        name: "Memphis Collection Colour Sample",
        category: "samples",
      },
      {
        name: "Norwegian Wood Veneer Sample",
        category: "samples",
      },
    ],
  },
  "collections/lacquered-fronts": {
    eventName: "view_item_list",
    items: [
      {
        name: "pure",
        category: "fronts/lacquered",
        variant: "greige",
      },
      {
        name: "classic",
        category: "fronts/lacquered",
        variant: "khaki",
      },
      {
        name: "modern",
        category: "fronts/lacquered",
        variant: "terracotta",
      },
      {
        name: "blade",
        category: "fronts/lacquered",
        variant: "honest-blue",
      },
      {
        name: "wave",
        category: "fronts/lacquered",
        variant: "butter-yellow",
      },
    ],
  },
  "fronts/veneered/blade": {
    eventName: "select_content",
    content_type: "product",
    items: [
      {
        name: "blade",
        category: "fronts/veneered",
      },
    ],
  },
  "fronts/veneered/modern": {
    eventName: "select_content",
    content_type: "product",
    items: [
      {
        name: "modern",
        category: "fronts/veneered",
      },
    ],
  },
  "fronts/veneered/pure": {
    eventName: "select_content",
    content_type: "product",
    items: [
      {
        name: "pure",
        category: "fronts/veneered",
      },
    ],
  },
  "fronts/veneered/stripe": {
    eventName: "select_content",
    content_type: "product",
    items: [
      {
        name: "stripe",
        category: "fronts/veneered",
      },
    ],
  },
  "fronts/lacquered/pure": {
    eventName: "select_content",
    content_type: "product",
    items: [
      {
        name: "pure",
        category: "fronts/lacquered",
      },
    ],
  },
  "fronts/lacquered/classic": {
    eventName: "select_content",
    content_type: "product",
    items: [
      {
        name: "classic",
        category: "fronts/lacquered",
      },
    ],
  },
  "fronts/lacquered/modern": {
    eventName: "select_content",
    content_type: "product",
    items: [
      {
        name: "modern",
        category: "fronts/lacquered",
      },
    ],
  },
  "fronts/lacquered/blade": {
    eventName: "select_content",
    content_type: "product",
    items: [
      {
        name: "blade",
        category: "fronts/lacquered",
      },
    ],
  },
  "fronts/lacquered/wave": {
    eventName: "select_content",
    content_type: "product",
    items: [
      {
        name: "wave",
        category: "fronts/lacquered",
      },
    ],
  },
}

export default productsMap
